export var ESectionStatus;
(function (ESectionStatus) {
  ESectionStatus["Deleted"] = "deleted";
  ESectionStatus["Draft"] = "draft";
  ESectionStatus["Published"] = "published";
})(ESectionStatus || (ESectionStatus = {}));